import InformationIcon from "@/app/(site)/_components/Atoms/Icons/InformationIcon"
import { clsx } from "@/src/utils/clsx"

interface InformationButtonProps {
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
    className?: string
    ariaLabel?: string
    inseta11y?: { before: string }
}

export default function InformationButton({
    onClick,
    className,
    ariaLabel,
    inseta11y = {
        before: "before:absolute before:inset-0 inset-0 before:-inset-x-2 before:-inset-y-2 before:content-['']"
    }
}: InformationButtonProps) {
    return (
        <button
            className={clsx(
                "relative text-main-light-grey-disabled transition-colors hover:text-main-black group-hover:text-main-black",
                className,
                inseta11y.before
            )}
            onClick={onClick}
            aria-label={ariaLabel}
        >
            <InformationIcon className="h-full w-full" />
        </button>
    )
}
